// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2ElMo","title":"Info_title___llQB","links":"Info_links___d-sT","link":"Info_link__ePV1L","logo":"Info_logo__14Dji"};